import { useEffect, useRef } from 'react'
import { AttachmentData } from '../../../../../../../@types/types'

export const useOnAttachmentAdded = (attachments: AttachmentData[], action: (index: number) => void) => {
  const prevLength = useRef(0)
  const isFirstRender = useRef(true)

  useEffect(() => {
    const newUploadingIndex = prevLength.current
    if (!isFirstRender.current && attachments.length > newUploadingIndex) {
      action(newUploadingIndex)
    }
    isFirstRender.current = false
    prevLength.current = attachments.length
  }, [attachments, action])
}
